import React from 'react';
import { Link } from 'react-router-dom';
import config from '../../config';

function DepartmentsPageSession() {
  return (
    <div className="services-details">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-5">
            <div className="services-details__sidebar">
              <div className="services-details__services-list">
                <ul className="services-details__services list-unstyled">
                  <li className="active">
                    <a href="/appliedbehavioral-analysis">Applied Behavioral Analysis</a>
                  </li>
                  <li>
                    <a href="/speech-language-pathology">Speech Language Pathology</a>
                  </li>
                  <li>
                    <a href="/occupational-therapy">Occupational Therapy</a>
                  </li>
                  <li>
                    <a href="/special-eduaction">Special Education</a>
                  </li>
                
                </ul>
              </div>
              <div className="banner-one">
                <div 
                  className="banner-one__bg"
                  style={{backgroundImage: "url(assets/images/backgrounds/ABA.png)"}}
                ></div>
                <div className="banner-one__shape-1 float-bob-x">
                  <img src="assets/images/shapes/Contact Us ROH.png" alt="" />
                </div>
                <h3 className="banner-one__title">
                  Have more questions?
                  <br /> We are here to help -
                  <br /> <b>Contact us</b>
                </h3>
                <div className="banner-one__btn-box">
                  <a href="/contact" className="banner-one__btn thm-btn">Contact Now</a>
                </div>
              </div>
              <div className="case-details__right">
                                <div className="case-details__info-box">
                                    <h3 className="case-details__info-title">Why ABA Matters</h3>
                                    <ul className=" case-details__info-list" style={{ listStyleType: 'disc',  color: '#8B4513' }}>
                                    <li>
                                        <p>A framework for learning, independence, and empowerment.</p>
                                    </li>
                                    <li>
                                        <p>Strengthens self-help and daily living skills</p>
                                    </li>
                                    <li>
                                        <p>Builds academic readiness and adaptive functioning</p>
                                    </li>
                                    <li>
                                        <p>Reduces behaviors that interfere with learning</p>
                                    </li>
                                    
                                    </ul>
                     </div>  
                </div>
            </div>
          </div>
          <div className="col-xl-8 col-lg-7">
            <div className="services-details__right">
              <div className="services-details__img">
                <img src="assets/images/services/ABAMain--770-377.jpg" alt="" />
              </div>
              <h3 className="services-details__title-1">Applied Behavioral Analysis</h3>
              <p className="services-details__text-1">
              Applied Behavior Analysis (ABA) is an empirical, evidence-based discipline grounded 
              in the principles of behavioral science. Our focus is on identifying functional relationships
               between behavior and environment and applying these principles to bring about socially 
               significant, lasting change. Research consistently shows that ABA can: Increase communication, 
               social, and play skills.
              </p><br/>
              <p className='services-details__text-2'> 
              ABA looks at observable and measurable behavior, using systematic assessment, data-driven 
              programming, and continuous progress monitoring. At its heart, ABA is about teaching skills 
              that matter — skills that help individuals communicate, connect, and thrive.
              </p><br/>
              <h4>What We Do</h4>
              <p>Our ABA therapy team specialises in supporting autistic children and other developmental needs. Each program is highly individualized and designed 
                to build meaningful skills while reducing barriers to learning.</p>
                <p>We use a variety of behavior-analytic teaching strategies, including:</p>
                <ul class="case-details__points list-unstyled" style={{paddingTop:10}}>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Discrete-Trial Instruction (DTI): Structured, step-by-step teaching with clear prompts and reinforcement.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Natural Environment Teaching (NET): Embedding learning in play and daily routines.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Incidental Teaching & Motivation-Based Learning: Capturing teachable moments when motivation is high.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Task Analysis & Chaining: Teaching complex skills by breaking them into smaller, achievable steps.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Errorless Learning & Prompt Fading: Ensuring early success while moving toward independence.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Differential Reinforcement (DRA, DRO, DRI, DRL): Strengthening positive behaviors while reducing challenging ones.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Shaping & Successive Approximations: Building new behaviors one small step at a time.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <span class="fa fa-check"></span>
                                            </div>
                                            <div class="text">
                                                <p>Functional Communication Training (FCT): Replacing problem behaviors with meaningful communication.</p>
                                            </div>
                                        </li>
                                        
                                    </ul>
              <div className="services-details__benefit">
                <div className="row">
                  <div className="col-xl-5">
                    <div className="services-details__benefit-img">
                      <img src="assets/images/services/ABAcircle - 369-369.jpg" alt="" />
                    </div>
                  </div>
                  <div className="col-xl-7">
                    <div className="services-details__benefit-content">
                      <h3 className="services-details__benefit-title">Our ABA Framework</h3>
                      <p className="services-details__benefit-text">
                       
                      </p>
                      <ul className="services-details__benefit-points list-unstyled">
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p><b>Individualized Assessments:</b> VB-MAPP, ABLLS-R </p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p><b>Data-Driven Decisions:</b>  Every program is tracked with direct data collection and visual analysis. </p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p><b>Generalization & Maintenance:</b> Skills taught in therapy are practiced in real-life settings and sustained over time. </p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p><b>Family Partnership:</b> Parents and caregivers receive hands-on training and support for consistency at home and in the community. </p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="fa fa-check"></span>
                          </div>
                          <div className="text">
                            <p><b>Ethical Practice:</b> Guided by the QABA Ethics Code, ensuring dignity, choice, and respect for each individual. </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <p style={{marginTop:10}}>At our center, ABA therapy means progress with purpose. Each session focuses on unlocking potential and building confidence 
                    through strength-based, child- and family-centered care. We honor the child’s assent, respect their individuality, and work 
                    alongside families to create meaningful growth and lasting change.</p>
                </div>
              </div>
             
              <h3 className="services-details__title-3">ABA Journey</h3>
              <ul className="services-details__process list-unstyled">
                <li>
                  <div className="icon">
                    {/* <span className="icon-form"></span> */}
                    <img src="assets/images/icons/Book appointment (2).png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Book <br/>Appointment</h3>
                  {/* <p>Lorem ipsum proin gravida <br /> nibh vel velit auctor <br /> aliquet.</p> */}
                </li>
                <li>
                  <div className="icon">
                  <img src="assets/images/icons/Assessment (2).png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Assessment with <br/>VB-MAPP</h3>
                  {/* <p>Lorem ipsum proin gravida <br /> nibh vel velit auctor <br /> aliquet.</p> */}
                </li>
                <li>
                  <div className="icon">
                    <img src="assets/images/icons/Tailored intervention.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Tailored Intervention <br/>Plan</h3>
                  {/* <p>Lorem ipsum proin gravida <br /> nibh vel velit auctor <br /> aliquet.</p> */}
                </li>
                <li>
                  <div className="icon">
                    <img src="assets/images/icons/Begin your.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Begin Your <br/>Sessions</h3>
                 </li>
              </ul>

              <div className="mt-5 mb-5 p-4 bg-light rounded-4 shadow-sm">
                <div className="section-title text-left mb-4">
                  <span className="section-title__tagline" style={{ color: '#166534', fontWeight: '700' }}>ABA Insights</span>
                  <h3 className="services-details__title-1" style={{ fontSize: '1.6rem', marginTop: '5px' }}>Featured ABA Article</h3>
                </div>
                <div className="row">
                  <div className="col-md-8 col-lg-7">
                    <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
                      <img src="/assets/images/blog/counselling-session.jpeg" className="card-img-top" alt="ABA Reimagined" style={{ height: '220px', objectFit: 'cover' }} />
                      <div className="card-body">
                        <span className="badge bg-success mb-2">ABA</span>
                        <h5 className="card-title fw-bold" style={{ fontSize: '1.1rem', lineHeight: '1.4' }}>
                          <Link to="/blog-details/aba-reimagined-blog-post" className="text-dark text-decoration-none">
                            ABA, Reimagined: Growing With What We've Learned
                          </Link>
                        </h5>
                        <p className="card-text text-muted small mt-2">
                          Imagine teaching a fish to climb a tree. Explore how conversations around neurodiversity are helping reshape autism intervention and therapy goals.
                        </p>
                        <Link to="/blog-details/aba-reimagined-blog-post" className="btn btn-sm btn-outline-success mt-2">
                          Read Full Article &rarr;
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            
              <div className="services-details__book">
                <div className="services-details__book-img">
                  <img src="assets/images/shapes/277-235.jpg" alt="" />
                </div>
                <div className="services-details__book-shape-1">
                  <img src="assets/images/shapes/services-details-book-shape-1.png" alt="" />
                </div>
                <div className="services-details__book-top">
                  <div className="icon">
                    <span className="icon-phone-call"></span>
                  </div>
                  <div className="content">
                    <p>Have Questions?</p>
                    
                  </div>
                </div>
                <div className="services-details__book-title-and-btn">
                  <h3 className="services-details__book-title">
                  Curious to know more?
                    <br /> We're just a call away — <b>Contact us.</b>
                  </h3>
                  <div className="services-details__book-btn-box">
                    <a href="/contact" className="services-details__book-btn thm-btn">
                      Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DepartmentsPageSession;